var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoiceChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99364 6.3125H3.69386V5.52083H2.99364V6.3125ZM4.9728 7.89583H5.67303V3.9375H4.9728V7.89583ZM7.14989 9.47917H7.85011V2.35417H7.14989V9.47917ZM9.32697 7.89583H10.0272V3.9375H9.32697V7.89583ZM11.3061 6.3125H12.0064V5.52083H11.3061V6.3125ZM0.375 13.8943V1.65394C0.375 1.28951 0.497049 0.985243 0.741146 0.741146C0.985243 0.497049 1.28951 0.375 1.65394 0.375H13.3461C13.7105 0.375 14.0148 0.497049 14.2589 0.741146C14.503 0.985243 14.625 1.28951 14.625 1.65394V10.1794C14.625 10.5438 14.503 10.8481 14.2589 11.0922C14.0148 11.3363 13.7105 11.4583 13.3461 11.4583H2.81096L0.375 13.8943Z",
    fill: "#2D76FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceChat);
export default __webpack_public_path__ + "static/media/voice_chat.75f3b5db6154bed2a66f50bd51952c21.svg";
export { ForwardRef as ReactComponent };